export function externalLink(url: string): boolean {
	return /^http(?:s)?:\/{2}\S+$/.test(url);
}
